import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';
import { downloadBulkUploadTemplate } from '../../utils/bulkUploadTemplates';

function UsersCreate() {
  const [activeTab, setActiveTab] = useState('single');
  const [fullName, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [address, setAddress] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [userCategory, setUserCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [tooltip, setTooltip] = useState('');
  const [uploadFile, setUploadFile] = useState(null); 
  const [enabled, setEnabled] = useState(true);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();

  const roleIdMapping = { admin: 1, archiver: 2, examiner: 3, 'data team': 4, security: 5 };

  useEffect(() => {
    axios.get('/api/user-categories?page=0&size=10&sortBy=id')
      .then(response => {
        const cats = response.data.content || response.data;
        setCategories(cats);
      })
      .catch(err => console.error('Error fetching categories', err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTooltip('');
    const payload = {
      fullName,
      username,
      email,
      contactNo,
      address,
      password,
      roles: [{ id: roleIdMapping[role] }],
      userCategory: { id: userCategory },
      enabled,
    };
    try {
      await axios.post('/api/users', payload, {
        headers: { 'Content-Type': 'application/json' }
      });
      setTooltip('User created successfully!');
      setTimeout(() => navigate('/admin/users/view'), 2000);
    } catch (err) {
      console.error(err);
      setTooltip('Error creating user.');
    }
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();
    if (!uploadFile) return;
    setIsUploading(true);         
    setUploadProgress(0);   
    const formData = new FormData();
    formData.append('file', uploadFile);
    try {
      await axios.post('/api/bulk-upload/user-create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent); 
        }
      });
      setTooltip('Users uploaded successfully!');
      setTimeout(() => navigate('/admin/users/view'), 2000);
    } catch (err) {
      let backendMessage = ' Unknown error occurred while uploading.';
        if (err.response && err.response.data) {
           if (typeof err.response.data === 'string') {
             backendMessage = err.response.data;
            }
            else if (typeof err.response.data.message === 'string') {
              backendMessage = err.response.data.message;
            }
        }
    setTooltip(`Error: ${backendMessage}`);
    }
    finally {
      setIsUploading(false);     
    }
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create New User" />

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === 'single' ? 'active' : ''}`}
            onClick={() => { setActiveTab('single'); setUploadFile(null); }}
          >
            Single Create
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
            onClick={() => setActiveTab('bulk')}
          >
            Bulk Upload
          </button>
        </li>
      </ul>

      {activeTab === 'single' ? (
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="mb-3">
          <label className="form-label">Full Name:</label>
          <input type="text" className="form-control" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Username:</label>
          <input type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Contact NO:</label>
          <input type="tel" className="form-control" value={contactNo} onChange={(e) => setContactNo(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Email:</label>
          <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Password:</label>
          <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="off" data-lpignore="true" data-1p-ignore="true" data-form-type="other" />
        </div>
        <div className="mb-3">
          <label className="form-label">Address OF Institution:</label>
          <input type="text" className="form-control" value={address} onChange={(e) => setAddress(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Role:</label>
          <select className="form-select" value={role} onChange={(e) => setRole(e.target.value)} required>
            <option value="">Select Role</option>
            <option value="admin">Admin</option>
            <option value="archiver">Archiver</option>
            <option value="examiner">Examiner</option>
            <option value="data team">Data Team</option>
            <option value="security">Security</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">User Category:</label>
          <select className="form-select" value={userCategory} onChange={(e) => setUserCategory(e.target.value)} required>
            <option value="">Select Category</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Enable Login:</label>
          <input
            type="checkbox"
            checked={enabled}
            onChange={e => setEnabled(e.target.checked)}
          />
          <span className="ms-2">{enabled ? 'Enabled' : 'Disabled'}</span>
        </div>
        <button type="submit" className="btn btn-primary">Create User</button>
      </form>
      )
      : (
        <form onSubmit={handleBulkSubmit}>
          <div className="mb-3">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => downloadBulkUploadTemplate('users')}
            >
              Download Template
            </button>
          </div>
          <div className="mb-3">
            <label className="form-label">Select Excel File</label>
            <input
              type="file"
              className="form-control"
              accept=".xls,.xlsx"
              onChange={(e) => {
                setUploadFile(e.target.files[0]);
                setIsUploading(false);
                setUploadProgress(0);
              }}              
            />
          </div>
          {uploadFile && (
            <p className="fst-italic">File selected: {uploadFile.name}</p>
          )}
          {isUploading && (
           <div className="progress mb-3">
             <div
               className="progress-bar progress-bar-striped progress-bar-animated"
               role="progressbar"
               style={{ width: `${uploadProgress}%` }}
             >
               {uploadProgress}%
             </div>
           </div>
         )}
          <button type="submit" className="btn btn-primary">Upload Users</button>
        </form>
      )}
    {tooltip && (
        <div className={`mt-3 alert ${tooltip.includes('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
    )}
    </div>
  );
}
export default UsersCreate;
